import * as actionTypes from "../actions/actionTypes";

const initialState = {
  appointments: [],
  loading: true,
  purchased: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.RETRIEVE_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        appointments: action.appointments,
      };
    default:
      return state;
  }
};

export default reducer;
